import {Directive, ElementRef, OnDestroy, OnInit} from '@angular/core';
import Grid from 'muuri';
import Muuri, {GridEvents} from 'muuri';
import {BehaviorSubject, of, Subscription} from 'rxjs';
import {debounceTime, delay, filter, take} from 'rxjs/operators';
import {DashboardFacade} from '../main/pages/dashboard/store/dashboard.facade';
import { PermissionsService } from 'app/global/permissions/permissions.service';
import { PermissionsEnum } from 'app/global/permissions/permissions.enum';

@Directive({
  selector: '[appMuuri]'
})
export class MuuriDirective implements OnInit, OnDestroy {

  layoutConfig = {
      items: [],
      layoutOnInit: false,
      dragEnabled: true,
      layout: {
          fillGaps: true,
          horizontal: false,
          alignRight: false,
          alignBottom: false,
          rounding: true
      },
      dragStartPredicate: {
          distance: 0,
          delay: 0,
          handle: '.tile-handle'
      },
      dragSortInterval: 0,
      
  };
  layout: Grid = null;
  addItemChangeSubscription: Subscription;
  canUploadDocumentSubscription: Subscription;

  private events: string[];
  private items: ElementRef[];
  private addItemChange = new BehaviorSubject<boolean>(false);
  public dashboardSettings$ = this.dashboardFacade.dashboardSettings$;
  public dashboardSettings: {[key:string] : string }  = null;
  public widgetsSorting: string | string[]= '';
  public timeOutSubscription!: Subscription;
  private canUploadDocument = true;

  constructor(private elRef: ElementRef, private dashboardFacade: DashboardFacade, private _permissionService: PermissionsService) {
      this.events = [];
      this.items = [];
  }

  ngOnInit(): void {
      this.addItemChangeSubscription = this.addItemChange
          .pipe(
              filter(t => !!t),
              debounceTime(25)
          )
          .subscribe(() => {
              this.addItems(this.items);
              this.refresh();
          });

      this.dashboardSettings$.subscribe((result) => {
        this.dashboardSettings = result;
        this.refreshWidgets();
      })

      this.dashboardFacade.refreshMurriWidgets.subscribe(() => {
        this.refreshWidgets();
      });

      this.canUploadDocumentSubscription = this._permissionService
        .isNotRestricted(PermissionsEnum.restrict_access_send_documents_not_templates)
        .subscribe((canUploadDocument) => {
          this.canUploadDocument = canUploadDocument;
          this.filter();
        });

      if(this.layout){
        this.destroyLayout();
      }
      this.init(this.elRef.nativeElement, true);
  }


 
  private refreshWidgets(){
    this.timeOutSubscription = of(null).pipe(
      take(1),
      delay(400)
    ).subscribe(() => {
      this.initCustomSorting();
      this.filter();
    });          
  }




  init(grid: HTMLElement, fillGaps: boolean, sortAction: string = null, dragHandle: string = null) {
    if (dragHandle) {
        //this.layoutConfig.dragStartPredicate.handle = dragHandle;
    }
    if (sortAction) {
       // this.layoutConfig.dragSortPredicate.action = sortAction;
    }
    this.layoutConfig.layout.fillGaps = fillGaps;
    this.layout = new Muuri(grid, this.layoutConfig);
    this.on('move', () => this.onMove());
  }

  filter(){
    if(this.layout)
    {
      this.refresh();
      let dashboardSettings = this.dashboardSettings;
      const canUploadDocument = this.canUploadDocument;
      this.layout.filter(function (item) {
        const sortId = item.getElement().getAttribute('sort-id');
        if(sortId === 'UploadDocument' && !canUploadDocument){
          return false;
        }
        if(dashboardSettings && Object.prototype.hasOwnProperty.call(dashboardSettings, sortId) && dashboardSettings[sortId] == 'active'){
          return true;
        }
      });
    }
  }

  initCustomSorting(){
    if(this.dashboardSettings?.widgetsSorting){
      const updatedWidgetsSorting = this.dashboardSettings?.widgetsSorting;
      if(updatedWidgetsSorting != '')// && updatedWidgetsSorting != this.widgetsSorting)
      {
        this.widgetsSorting = updatedWidgetsSorting;
        this.sortLayout();
      }
    }
  }

  sortLayout()
  {
    if(this.layout && this.widgetsSorting != '')
    {
      const updatedWidgetsSorting = JSON.parse(this.widgetsSorting as string);
      const currentItems = this.layout.getItems();
      const currentItemIds = this.serializeLayout();

      const newItems = [];
      let itemId;
      let itemIndex;

      for (let i = 0; i < updatedWidgetsSorting.length; i++) {
          itemId = updatedWidgetsSorting[i];
          itemIndex = currentItemIds.indexOf(itemId);
          if (itemIndex > -1) {
              newItems.push(currentItems[itemIndex])
          }
      }
      this.layout.sort(newItems, { layout: 'instant' });
    }
  }

  serializeLayout() 
  {
    const itemIds = this.layout.getItems().map(function (item) {
      return item.getElement().getAttribute('sort-id');
    });

    return itemIds;
  }

  onMove() {
    this.widgetsSorting = this.serializeLayout();
    this.dashboardFacade.updateDashboardSetting('widgetsSorting', JSON.stringify(this.widgetsSorting));
  }

  private addItems(items) {
      const existingItems = this.layout.getItems();
      if (existingItems && existingItems.length > 0) {
          this.layout.remove(existingItems, { layout: false });
      }

      this.layout.add(items, { layout: false });
      this.items = [];
  }

  addItem(item: ElementRef) {
      this.items.push(item);
      this.addItemChange.next(true);
  }

  on(eventName: string, action: (item, event)=>void) {
      if (this.events.find(x => x === eventName)) {
          return;
      }

      this.layout.on(eventName as keyof GridEvents, function(item, event) {
          action(item, event);
      });
      this.events.push(eventName);
  }

  destroyLayout() {
      this.events.forEach(eventName => {
          this.layout.off(eventName as keyof GridEvents, null);
      });
      this.events = [];

      this.layout.destroy();
      this.layout = null;
  }

  refresh() {
      this.layout.refreshItems();
      this.layout.layout();
  }

  ngOnDestroy(): void {
      this.destroyLayout();
      if (this.addItemChangeSubscription) {
          this.addItemChangeSubscription.unsubscribe();
      }
      if (this.canUploadDocumentSubscription) {
          this.canUploadDocumentSubscription.unsubscribe();
      }
  }
}
